/*
	[ Static ] fields:
	- These fields values don't usually change. They stay the same for long periods
	- ETag caching can work automatically on separate endpoints which provide this static data
 */

import { Currency } from "@models/interfaces/currency";

export abstract class TradableStatic extends Currency {
	protected asset_group_name: string = "";
	protected color: string = "";
	protected logo: string = "";
	protected logo_dark: string = "";
	protected name: string = "";
	protected precision_for_coins: number = 0;
	protected precision_for_fiat_price: number = 0;
	protected precision_for_tx = 8;
	protected support_destination_tag = false;
	protected symbol: string = "";
	protected url_check_address: string = "";
	protected url_check_transaction: string = "";

	public getAssetGroupName(): string {
		return this.asset_group_name;
	}

	public getAssetSymbol(): string {
		return this.symbol;
	}

	public getColor(): string {
		return this.color;
	}

	public getPrecision(): number {
		return this.precision_for_coins;
	}

	public getPrecisionFiat(): number {
		return this.precision_for_fiat_price;
	}

	public getPrecisionForTx(): number {
		return this.precision_for_tx;
	}

	public getSupportsDestinationTag(): boolean {
		return this.support_destination_tag;
	}

	public urlCheckAddress(): string {
		return this.url_check_address;
	}

	public urlCheckTransaction(): string {
		return this.url_check_transaction;
	}
}
